<div class="brand-header">
  <ng-container *ngIf="data.logo">
    <img [src]="data.logo" class="brand-logo" alt="{{data.companyName}}">
  </ng-container>
  <div class="brand-details">
    <h1>{{ data.companyName | camelcase}}</h1>
    <ng-container *ngIf="data.url">
      <a class="data-url" (click)="sanitizeUrl(data.url); $event.preventDefault();"
      rel="noopener noreferrer"
      >{{ data.url }}</a>
    </ng-container>
  </div>
</div>
<div class="total-results d-none d-lg-block  d-md-block">
  <strong>Total Results {{ products.length }} </strong>
</div>
<div class="parent-container">
  <div class="filter">
    <app-brand-product-filter [data]="originalData"   [brandProfileProducts]="brandProfileProducts" [filterColumns]="['Products', 'Region']" [heading]="'Search Distributors'" (filteredData)="onFilteredData($event)"></app-brand-product-filter>
  </div>
  <div class="total-results1 d-lg-none  d-md-none">
    <strong>Total Results {{ products.length }} </strong>
  </div>
    <div class="product-list">
      <div *ngIf="products.length===0"  class="no-results">
        <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
        <div class="no-records-found"> No Distributors Found </div>
      </div>
      <div class="card" *ngFor="let product of paginatedItems">
        <div style="display: flex; height: 150px; justify-content: center; align-items: center ">
          <img [src]="(product?.logo !== null && product?.logo !== '') ? product?.logo : distributorDefaultLogo" alt="{{ product.distributorName }}"  style="    max-width: 260px;
    max-height: 150px;" >
        </div>
        <div *ngIf="isLoggedIn" class="card-content">
          <h2>{{ product.companyName }}</h2>
          <hr/>
          <ul class="card-info">
            <li class="list-inline-item d-flex align-items-center">
              <span class="icon me-2">
                <img src="../../../assets/images/icons/avatar-icon.svg" alt="avatar">
              </span>
              <span>{{ product.distributorName }}</span>
            </li>

            <li style="text-align: left;">
              <span class="icon"><img src="../../../assets/images/location_symbol.svg" alt="address"/></span>
               <ng-container *ngIf="product?.address || product?.city || product?.country; else notMentioned">
                 <span *ngIf="product?.address">{{ product?.address | slice:0:15 }},</span>
                 <span *ngIf="product?.city"> {{ product?.city | slice:0:15 }}, </span>
                 <span *ngIf="product?.country">{{ product?.country | slice:0:15 }}</span>
               </ng-container>
               <ng-template #notMentioned>
                 Not Mentioned
               </ng-template>
            </li>
            <li>
              <span class="icon"><img src="../../../assets/images/phone rings.svg" alt="phone"/></span>
             <span>{{ product?.phoneCode }} {{ product?.phoneNumber }}</span>
            </li>
            <li style="white-space: normal; word-break: break-all; text-align: left;">
              <span class="icon"><img src="../../../assets/images/email.svg" alt="email"/></span>
             <span> {{ product?.email }}</span>
            </li>
          </ul>
        </div>
        <button *ngIf="isLoggedIn" (click)="onViewProfileClick(product)">View Profile</button>
        <div *ngIf="!isLoggedIn" class="signin" (click)="onLoginPage()">
          <p class="d-flex align-content-center justify-content-center flex-column "> Sign in for more </p>
          <p class="d-flex align-content-center justify-content-center flex-column "> Information </p>
        </div>
      </div>
    </div>
    </div>
    <div class="pagination-container">
      <app-pagination [itemsPerPage]="itemsPerPage" [data]="products" (pageChanged)="onPageChanged($event)"></app-pagination>
    </div>
